import React from 'react';
import ReactDOM from 'react-dom/client';
import EMRApp from 'views/EMR';
import IntakeApp from 'views/Intake';
import '@populateui/core/defaults.css';
import 'styles/index.css';
import {
  preloadDancingScriptFont,
} from 'utils/fonts';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const isEMR = true;

preloadDancingScriptFont();

root.render(isEMR ? <EMRApp /> : <IntakeApp />);
